<template>
  <div class="container">
    <h2 class="title">机构类型管理</h2>
    <el-button type="primary" @click="openAddTypeDialog">添加机构类型</el-button>
    <el-table :data="paginatedTypes" style="width: 100%; margin-top: 20px;">
      <el-table-column prop="typeName" label="机构类型名称" width="180"></el-table-column>
      <el-table-column prop="description" label="机构类型描述"></el-table-column>
      <el-table-column prop="count" label="机构数量" width="150"></el-table-column>
      <el-table-column label="操作" width="250">
        <template #default="scope">
          <div style="display: flex; justify-content: space-between;">
            <el-button size="mini" @click="openEditTypeDialog(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteType(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        layout="prev, pager, next"
        :total="totalItems"
        :page-size="pageSize"
        @current-change="handlePageChange"
        style="margin-top: 20px;"
    ></el-pagination>

    <!-- 添加/编辑机构类型的弹窗 -->
    <el-dialog v-model="typeDialogVisible" :title="dialogTitle">
      <el-form :model="currentType">
        <el-form-item label="机构类型名称">
          <el-input v-model="currentType.typeName"></el-input>
        </el-form-item>
        <el-form-item label="机构类型描述">
          <el-input v-model="currentType.description"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="typeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleTypeSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import axios from "@/axios";

export default {
  data() {
    return {
      types: [], // 机构类型列表
      typeDialogVisible: false, // 添加/编辑对话框的显示状态
      dialogTitle: "", // 对话框标题
      currentType: { typeName: "", description: "", count: 0 }, // 当前操作的机构类型
      currentPage: 1, // 当前页码
      pageSize: 5, // 每页显示的条数
      totalItems: 0 // 总条数
    };
  },
  computed: {
    paginatedTypes() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.types.slice(start, end);
    }
  },
  mounted() {
    this.fetchTypes();
  },
  methods: {
    fetchTypes() {
      axios.get("/OrganizationType/list")
          .then(response => {
            if (!response.data.success) {
              this.showErrorMessage(response.data.errorMsg);
              return;
            }
            this.types = response.data.data;
            this.totalItems = this.types.length;
          })
          .catch(error => {
            console.error("获取机构类型信息失败:", error);
            this.showErrorMessage("获取机构类型信息失败");
          });
    },
    showSuccessMessage(message) {
      ElMessage({
        message: message,
        type: "success",
        duration: 1500
      });
    },
    showErrorMessage(message) {
      ElMessage({
        message: message,
        type: "error",
        duration: 1500
      });
    },
    openAddTypeDialog() {
      this.dialogTitle = "添加机构类型";
      this.currentType = { typeName: "", description: "", count: 0 };
      this.typeDialogVisible = true;
    },
    openEditTypeDialog(type) {
      this.dialogTitle = "编辑机构类型";
      this.currentType = { ...type };
      this.typeDialogVisible = true;
    },
    handleTypeSubmit() {
      if (this.dialogTitle === "添加机构类型") {
        axios.post("/OrganizationType/add", this.currentType)
            .then(response => {
              if (!response.data.success) {
                this.showErrorMessage(response.data.errorMsg);
                return;
              }
              this.showSuccessMessage(response.data.data);
              this.types.push({ ...this.currentType });
              this.totalItems = this.types.length;
              this.fetchTypes()
            })
            .catch(error => {
              console.error("添加机构类型失败:", error);
              this.showErrorMessage("添加机构类型失败");
            });
      } else {
        axios.post("/OrganizationType/update", this.currentType)
            .then(response => {
              if (!response.data.success) {
                this.showErrorMessage(response.data.errorMsg);
                return;
              }
              this.fetchTypes()
              this.showSuccessMessage(response.data.data);
              const index = this.types.findIndex(t => t.typeName === this.currentType.typeName);
              if (index !== -1) {
                this.types.splice(index, 1, { ...this.currentType });
              }

            })
            .catch(error => {
              console.error("编辑机构类型失败:", error);
              this.showErrorMessage("编辑机构类型失败");
            });
      }
      this.typeDialogVisible = false;
    },
    deleteType(type) {
      axios.delete(`/OrganizationType/delete/${type.id}`)
          .then(response => {
            if (!response.data.success) {
              this.showErrorMessage(response.data.errorMsg);
              return;
            }
            this.fetchTypes()
            const index = this.types.findIndex(t => t.typeName === type.typeName);
            if (index !== -1) {
              this.types.splice(index, 1);
              this.showSuccessMessage("删除成功");
              this.totalItems = this.types.length;
            }
          })
          .catch(error => {
            console.log("删除机构类型失败:", error);
            this.showErrorMessage("删除机构类型失败");
          });
    },
    handlePageChange(page) {
      this.currentPage = page;
    }
  }
};
</script>

<style scoped>
.container {
  padding: 20px;
}
.title {
  color: #25ab88;
  text-shadow: 2px 2px 4px #25ab88;
  text-align: center;
  margin-bottom: 20px;
}
.el-button {
  margin-bottom: 20px;
}
.dialog-footer {
  text-align: right;
}
</style>
